@if(isLoading) {
    <div class="d-flex justify-content-center align-items-center" style="min-height: 400px;">
        <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;"></div>
    </div>
}

@if(company && !isLoading) {
    <div class="company-detail-page">
        <div class="container-fluid px-3 px-lg-5 py-4">
            <div class="row g-4 justify-content-center">
                <!-- LEFT COLUMN - GALLERY + MAIN CONTENT -->
                <div class="col-lg-6 order-2 order-lg-2">
                    <!-- GALLERY SECTION (Autoscout24 style) -->
                    <div class="gallery-container">
                        <!-- MAIN IMAGE -->
                        <div class="main-gallery-image">
                            @if(company.gallery && company.gallery.length > 0) {
                                <img [src]="company.gallery[currentImage || 0].startsWith('/') ? apiUrl + company.gallery[currentImage || 0] : company.gallery[currentImage || 0]" 
                                     alt="Photo principale" 
                                     class="gallery-main-img"
                                     (click)="openLightbox(currentImage || 0)">
                                <div class="image-counter-badge">
                                    <i class="bi bi-camera-fill me-1"></i>
                                    {{ (currentImage || 0) + 1 }} / {{ company.gallery.length }}
                                </div>
                            } @else if(company.logo) {
                                <img [src]="company.logo.startsWith('/') ? apiUrl + company.logo : company.logo" 
                                     alt="Logo" 
                                     class="gallery-main-img">
                            } @else {
                                <div class="gallery-main-img placeholder">
                                    <i class="bi bi-building" style="font-size: 4rem; color: #ccc;"></i>
                                </div>
                            }
                        </div>
                        
                        <!-- THUMBNAIL GRID -->
                        @if(company.gallery && company.gallery.length > 1) {
                            <div class="gallery-thumbnails-grid">
                                @for(img of company.gallery.slice(0, 8); track $index) {
                                    <div class="gallery-thumb-item" 
                                         [class.active]="currentImage === $index"
                                         (click)="currentImage = $index">
                                        <img [src]="img.startsWith('/') ? apiUrl + img : img" alt="Miniature">
                                        @if($index === 7 && company.gallery.length > 8) {
                                            <div class="thumb-overlay-more">
                                                <span>+{{ company.gallery.length - 8 }}</span>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        }
                    </div>

                    <!-- KEY DETAILS CARD -->
                    <div class="info-card mt-4">
                        <h3 class="section-title">
                            <i class="bi bi-info-circle me-2"></i>
                            Informations clés
                        </h3>
                        <div class="key-details-grid">
                            @if(company.companyNumber) {
                                <div class="detail-item">
                                    <div class="detail-label">Numéro d'entreprise</div>
                                    <div class="detail-value">{{ company.companyNumber }}</div>
                                </div>
                            }
                            @if(company.category) {
                                <div class="detail-item">
                                    <div class="detail-label">Catégorie</div>
                                    <div class="detail-value">{{ company.category }}</div>
                                </div>
                            }
                            @if(company.address) {
                                <div class="detail-item">
                                    <div class="detail-label">Ville</div>
                                    <div class="detail-value">{{ company.address.city }}</div>
                                </div>
                            }
                            @if(company.companyPhoneNumber) {
                                <div class="detail-item">
                                    <div class="detail-label">Téléphone</div>
                                    <div class="detail-value">{{ company.companyPhoneNumber }}</div>
                                </div>
                            }
                        </div>
                    </div>

                    <!-- DESCRIPTION -->
                    @if(company.description) {
                        <div class="info-card">
                            <h3 class="section-title">
                                <i class="bi bi-text-left me-2"></i>
                                Description
                            </h3>
                            <p class="description-text">{{ company.description }}</p>
                        </div>
                    }

                    <!-- RATINGS SECTION -->
                    <div class="info-card">
                        <h3 class="section-title">
                            <i class="bi bi-chat-left-text me-2"></i>
                            Évaluations et commentaires
                        </h3>

                        <!-- RATING FORM -->
                        <div class="rating-form-container">
                            <form (submit)="submitRating($event)">
                                <label class="form-label fw-semibold mb-2">Évaluez cette entreprise</label>
                                <!-- QUALITY -->
                                <div class="mb-2">
                                <span class="fw-semibold">Qualité :</span><br/>
                                <div class="star-rating d-inline-block ms-2">
                                    @for(star of [1,2,3,4,5]; track $index) {
                                    <i class="bi star-icon"
                                        [class.bi-star-fill]="selectedScores.quality >= star"
                                        [class.bi-star]="selectedScores.quality < star"
                                        [class.active]="selectedScores.quality >= star"
                                        (click)="setScore('quality', star)">
                                    </i>
                                    }
                                </div>
                                </div>

                                <!-- PRICE -->
                                <div class="mb-2">
                                <span class="fw-semibold">Prix :</span><br/>
                                <div class="star-rating d-inline-block ms-2">
                                    @for(star of [1,2,3,4,5]; track $index) {
                                    <i class="bi star-icon"
                                        [class.bi-star-fill]="selectedScores.price >= star"
                                        [class.bi-star]="selectedScores.price < star"
                                        [class.active]="selectedScores.price >= star"
                                        (click)="setScore('price', star)">
                                    </i>
                                    }
                                </div>
                                </div>

                                <!-- PUNCTUALITY -->
                                <div class="mb-2">
                                <span class="fw-semibold">Ponctualité :</span><br/>
                                <div class="star-rating d-inline-block ms-2">
                                    @for(star of [1,2,3,4,5]; track $index) {
                                    <i class="bi star-icon"
                                        [class.bi-star-fill]="selectedScores.punctuality >= star"
                                        [class.bi-star]="selectedScores.punctuality < star"
                                        [class.active]="selectedScores.punctuality >= star"
                                        (click)="setScore('punctuality', star)">
                                    </i>
                                    }
                                </div>
                                </div>

                                <!-- COMMUNICATION -->
                                <div class="mb-3">
                                <span class="fw-semibold">Communication :</span><br/>
                                <div class="star-rating d-inline-block ms-2">
                                    @for(star of [1,2,3,4,5]; track $index) {
                                    <i class="bi star-icon"
                                        [class.bi-star-fill]="selectedScores.communication >= star"
                                        [class.bi-star]="selectedScores.communication < star"
                                        [class.active]="selectedScores.communication >= star"
                                        (click)="setScore('communication', star)">
                                    </i>
                                    }
                                </div>
                                </div>

                                <!-- BUTTON -->
                                <div class="d-flex align-items-center gap-3">
                                @if(hasUserRating()) {
                                    <button type="submit" class="btn btn-sm btn-primary">
                                    <i class="bi bi-pencil me-1"></i>
                                    Modifier
                                    </button>
                                } @else {
                                    <button type="submit" class="btn btn-sm btn-primary">
                                    <i class="bi bi-check-lg me-1"></i>
                                    Publier
                                    </button>
                                }
                                </div>
                            </form>
                        </div>

                        <!-- COMMENT FORM -->
                        <div class="comment-form-container mt-4">
                            <form (submit)="submitComment($event)">
                                <label class="form-label fw-semibold mb-2">Laissez un commentaire :</label>
                                <textarea [(ngModel)]="newComment" 
                                          name="comment" 
                                          rows="4" 
                                          class="form-control modern-input mb-3"
                                          placeholder="Partagez votre expérience avec cette entreprise..."></textarea>
                                <button type="submit" class="btn btn-primary">
                                    <i class="bi bi-send me-2"></i>
                                    Publier le commentaire
                                </button>
                            </form>
                        </div>

                        <!-- COMMENTS LIST -->
                        <div class="mt-4">
                            <app-comment-list [company]="company"></app-comment-list>
                        </div>
                    </div>
                </div>

                <!-- RIGHT COLUMN - CONTACT SIDEBAR -->
                <div class="col-lg-4 order-1 order-lg-1">
                    <!-- TITLE & RATING CARD -->
                    <div class="info-card">
                        <div class="d-flex justify-content-between align-items-start mb-3">
                            <div>
                                <h1 class="company-title mb-2">{{ company.companyName }}</h1>
                                <span class="category-badge">{{ company.category }}</span>
                            </div>
                            <button class="btn-favorite" (click)="toggleFavorite(company)">
                                @if (currentUser?.favorites?.includes(company._id)) {
                                    <i class="bi bi-heart-fill"></i>
                                } @else {
                                    <i class="bi bi-heart"></i>
                                }
                            </button>
                        </div>
                        
                        <div class="stats-row">
                            <div class="stat-item">
                                <i class="bi bi-star-fill text-warning"></i>
                                <span class="ms-2"><strong>{{ company.averageRating || 0 }}/5</strong> ({{ company.ratings ? company.ratings.length : 0 }} Évaluations)</span>
                            </div>
                            <div class="stat-item">
                                <i class="bi bi-eye-fill text-primary"></i>
                                <span class="ms-2">{{ company.totalViews }} consultations</span>
                            </div>
                        </div>

                        @if(company.socialMediaLinks) {
                            <div class="social-links mt-3">
                                @if(company.socialMediaLinks.facebook) {
                                    <a [href]="company.socialMediaLinks.facebook" target="_blank" class="social-link facebook">
                                        <i class="bi bi-facebook"></i>
                                    </a>
                                }
                                @if(company.socialMediaLinks.instagram) {
                                    <a [href]="company.socialMediaLinks.instagram" target="_blank" class="social-link instagram">
                                        <i class="bi bi-instagram"></i>
                                    </a>
                                }
                                @if(company.socialMediaLinks.linkedin) {
                                    <a [href]="company.socialMediaLinks.linkedin" target="_blank" class="social-link linkedin">
                                        <i class="bi bi-linkedin"></i>
                                    </a>
                                }
                            </div>
                        }
                    </div>

                    <div class="sticky-sidebar">
                        <!-- CONTACT CARD -->
                        <div class="contact-card">
                            <h3 class="contact-title">
                                <i class="bi bi-telephone-fill me-2"></i>
                                Contacter l'entreprise
                            </h3>
                            
                            <button class="btn btn-primary btn-lg w-100 mb-3" 
                                    (click)="openEmailDialog(currentUser?.email || '', company.companyEmail)">
                                <i class="bi bi-envelope-fill me-2"></i>
                                Envoyer un email
                            </button>

                            @if(company.companyPhoneNumber) {
                                <a href="tel:{{ company.companyPhoneNumber }}" class="btn btn-outline-primary btn-lg w-100 mb-3">
                                    <i class="bi bi-telephone-fill me-2"></i>
                                    Appeler
                                </a>
                            }
                            <!-- 
                            <div class="contact-info mt-4">
                                @if(company.companyEmail) {
                                    <div class="contact-info-item">
                                        <i class="bi bi-envelope"></i>
                                        <div>
                                            <div class="info-label">Email</div>
                                            <div class="info-value">{{ company.companyEmail }}</div>
                                        </div>
                                    </div>
                                }

                                @if(company.companyPhoneNumber) {
                                    <div class="contact-info-item">
                                        <i class="bi bi-telephone"></i>
                                        <div>
                                            <div class="info-label">Téléphone</div>
                                            <div class="info-value">{{ company.companyPhoneNumber }}</div>
                                        </div>
                                    </div>
                                }
                            </div> 
                            -->
                        </div>

                        <!-- ADDRESS CARD -->
                        @if(company.address) {
                            <div class="contact-card mt-3">
                                <h3 class="contact-title">
                                    <i class="bi bi-geo-alt-fill me-2"></i>
                                    Adresse
                                </h3>
                                <div class="address-content">
                                    <p class="mb-1">{{ company.address.number }} {{ company.address.street }}</p>
                                    <p class="mb-0">{{ company.address.zipCode }} {{ company.address.city }}</p>
                                    <p class="text-muted mb-0">{{ company.address.country }}</p>
                                </div>
                                <!-- 
                                <button class="btn btn-outline-secondary w-100 mt-3">
                                    <i class="bi bi-map me-2"></i>
                                    Voir sur la carte
                                </button> 
                                -->
                            </div>
                        }

                        <!-- LOGO CARD -->
                        @if(company.logo) {
                            <div class="contact-card mt-3 text-center">
                                <img [src]="company.logo.startsWith('/') ? apiUrl + company.logo : company.logo" 
                                     alt="Logo" 
                                     class="company-logo">
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>

        <!-- LIGHTBOX -->
        @if(lightboxOpen) {
            <div class="lightbox-overlay" (click)="closeLightbox()">
                <button class="lightbox-close">
                    <i class="bi bi-x-lg"></i>
                </button>
                <img [src]="company.gallery[currentImage].startsWith('/') ? apiUrl + company.gallery[currentImage] : company.gallery[currentImage]" 
                     class="lightbox-image"
                     (click)="$event.stopPropagation()">
                
                @if(company.gallery.length > 1) {
                    <button class="lightbox-nav-btn prev" (click)="prevImage($event)">
                        <i class="bi bi-chevron-left"></i>
                    </button>
                    <button class="lightbox-nav-btn next" (click)="nextImage($event)">
                        <i class="bi bi-chevron-right"></i>
                    </button>
                }
                
                <div class="lightbox-counter">
                    {{ currentImage + 1 }} / {{ company.gallery.length }}
                </div>
            </div>
        }
    </div>
}